// IMPORT PACKAGE REFERENCES
import React from 'react';

// IMPORT PROJECT REFERENCES
import { DeviceDetails } from '../../DeviceBrowser/DeviceDetails';

// COMPONENT

export const DevicePage = ({ match }) => {
    return (<div className="animated fadeIn">
                <DeviceDetails deviceId={match.params.deviceId} />
            </div>);
}